import { render, staticRenderFns } from "./form_pack.vue?vue&type=template&id=35410806&scoped=true&"
import script from "./form_pack.vue?vue&type=script&lang=js&"
export * from "./form_pack.vue?vue&type=script&lang=js&"
import style0 from "./form_pack.vue?vue&type=style&index=0&id=35410806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35410806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35410806')) {
      api.createRecord('35410806', component.options)
    } else {
      api.reload('35410806', component.options)
    }
    module.hot.accept("./form_pack.vue?vue&type=template&id=35410806&scoped=true&", function () {
      api.rerender('35410806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/net_bar/device_price/form_pack.vue"
export default component.exports